// extracted by mini-css-extract-plugin
module.exports = {"container":"BrandIcon_container___1xPe"};